import PropTypes from 'prop-types';
import React from 'react';
import TitleHeader from '../../Pages/components/TitleHeader';
import icon from '../../../assets/images/exhibition-module-grey.svg';
import PageHeader from './components/PageHeader/PageHeader';
import TableHeader from './components/TableHeader/TableHeader';
import DiscountSummaryBox from './components/DiscountSummaryBox/DiscountSummaryBoxContainer';
import FairProductsList from './components/FairProductsList/FairProductsList';
import FairCartButton from './components/FairCartButton/FairCartButton';

class Fair extends React.Component {
    render() {
        const {
            data,
            selectedProductType,
            selectedSuppliers,
            suppliers,
            searchTerm,
            handleSelectSuppliers,
            handleSearch,
            handleFetchData,
            itemsCount,
            isLoading,
            handleProductTypeSelect,
            fairCartProducts,
            showDynamicWeeksButton,
            disableDynamicWeeksButton,
            handleDynamicWeeksClick,
            handleToggleColumn,
            showProductPhoto,
            setFairProducts,
            addProduct,
            loadingState,
            downloadPdf,
            weekAbbreviation,
            onMailFairCart,
            isMailLoading,
        } = this.props;

        const cartCount = Object.keys(fairCartProducts || {}).length;

        return (
            <div className="cart fair-page">
                <TitleHeader
                    title="fair.title"
                    icon={icon}
                    className="title-header__body--fair"
                    actions={
                        <FairCartButton
                            cartCount={cartCount}
                            onMailClick={onMailFairCart}
                            isMailLoading={isMailLoading}
                        />
                    }
                >
                    <PageHeader
                        handleProductTypeSelect={handleProductTypeSelect}
                        fairCartProducts={fairCartProducts}
                        selectedProductType={selectedProductType}
                        selectedSuppliers={selectedSuppliers}
                        suppliers={suppliers}
                        searchTerm={searchTerm}
                        handleSelectSuppliers={handleSelectSuppliers}
                        handleSearch={handleSearch}
                    />
                </TitleHeader>

                <div className="fair-page__body">
                    <TableHeader
                        showDynamicWeeksButton={showDynamicWeeksButton}
                        disableDynamicWeeksButton={disableDynamicWeeksButton}
                        handleDynamicWeeksClick={handleDynamicWeeksClick}
                    />
                    <FairProductsList
                        data={data}
                        itemsCount={itemsCount}
                        isLoading={isLoading}
                        selectedProductType={selectedProductType}
                        showProductPhoto={showProductPhoto}
                        onTogglePhoto={handleToggleColumn}
                        onFetchData={handleFetchData}
                        addProduct={addProduct}
                        setFairProducts={setFairProducts}
                        loadingState={loadingState}
                        downloadPdf={downloadPdf}
                        weekAbbreviation={weekAbbreviation}
                    />
                </div>
                <DiscountSummaryBox />
            </div>
        );
    }
}

Fair.propTypes = {
    data: PropTypes.array,
};

export default Fair;
